/* eslint-disable react/prop-types */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError, formValueSelector } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import MuiRaisedButton from 'material-ui/RaisedButton';
import Icon, { NAMES } from '@ifit/react-icons';
import { shark } from '../../theme/colors';
import { Navigation } from '../../navigation/react-redux-nav';
import { sendResetPasswordEmail } from '../../store/ducks/user';

import styles from '../../shared-styles';
import './index.css';

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);

    this.state = { resetEmailSent: false };
  }

  validateEmail = (email = '') => {
    const emailRegex = /^[^@^\s]+@[^@^\s]+\.[^@^\s]+$/;

    if (email && !emailRegex.test(email)) {
      return 'Valid email required.';
    }
  }

  submitForm = async (values) => {
    try {
      await this.props.sendResetPasswordEmail(values.email);
      this.setState({ resetEmailSent: true });
    } catch (err) {
      throw new SubmissionError({ email: err.message });
    }
  }

  handleSubmit = this.props.handleSubmit(this.submitForm)

  render() {
    return (
      <div className={ classNames('forgot-password-page', this.props.mediaType) }>
        <Navigation.Backward>
          <Icon
            name={ NAMES.ARROW_LEFT }
            color={ shark }
            size={ 24 }
            unitSize="px"
          />
        </Navigation.Backward>
        <form onSubmit={ this.handleSubmit }>
          <h1>Let's get you a new password.</h1>
          <Field
            name="email"
            type="email"
            component={ TextField }
            className="email-field"
            hintText="Enter your email"
            floatingLabelText="Email address"
            fullWidth={ true }
            autoCapitalize="off"
            autoCorrect="off"
            autoComplete="email"
            autoFocus
            validate={ this.validateEmail }
          />
          {
            this.state.resetEmailSent
              ? <p>An email has been sent with a link to reset your password.</p>
              : null
          }
          <MuiRaisedButton
            className="button reset-button"
            type="submit"
            label="Reset Password"
            primary={ true }
            fullWidth={ true }
            style={ styles.buttonStyle }
            labelStyle={ styles.buttonLabelStyle }
            disabled={ !this.props.email || this.props.invalid || this.props.submitting }
          />
          { !this.props.submitting && this.props.error
            ? <p className="error-text" style={ styles.errorStyle }>{ this.props.error }</p>
            : null
          }
        </form>
      </div>
    );
  }
}

const selector = formValueSelector('resetPassword');

ForgotPasswordPage = reduxForm({
  form: 'resetPassword',
})(ForgotPasswordPage);

ForgotPasswordPage.propTypes = {
  mediaType: PropTypes.string
};

export default connect(
  state => ({
    mediaType: state.config.mediaType,
    email: selector(state, 'email')
  }),
  dispatch => ({
    sendResetPasswordEmail: async (email) => {
      await dispatch(sendResetPasswordEmail(email));
    }
  })
)(ForgotPasswordPage);
